import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

// Dynamically import Leaflet components
const MapContainer = dynamic(() => import('react-leaflet').then(m => m.MapContainer), { ssr: false });
const TileLayer = dynamic(() => import('react-leaflet').then(m => m.TileLayer), { ssr: false });
const Marker = dynamic(() => import('react-leaflet').then(m => m.Marker), { ssr: false });
const Popup = dynamic(() => import('react-leaflet').then(m => m.Popup), { ssr: false });

export default function PickupLeafletMap({ center, zoom }) {
  const [ready, setReady] = useState(false);
  const [LRef, setLRef] = useState(null); // Capture loaded Leaflet reference
  const mapCenter = center || [37.349451032215725, -121.89007902908241];
  const zoomLevel = zoom || 12;

  useEffect(() => {
    async function loadLeafletAssets() {
      await import('leaflet/dist/leaflet.css');
      await import('leaflet-gesture-handling/dist/leaflet-gesture-handling.css');
      const L = await import('leaflet');
      await import('leaflet-gesture-handling');
      setLRef(L); // Save reference
      setReady(true);
    }

    loadLeafletAssets();
  }, []);

  if (!ready || !LRef) {
    return (
      <div
        className="bg-neutral-250 w-100 flex align-center justify-content-center br-300"
        style={{ height: '600px' }}
      >
        Loading Map...
      </div>
    );
  }

  const customIcon = LRef.icon({
    iconUrl: '/location-lotus.svg',
    iconSize: [60, 60],
    iconAnchor: [30, 60],
    popupAnchor: [0, -60],
  });

  return (
    <div className="full-width-map">
    <MapContainer
      center={mapCenter}
      zoom={zoomLevel}
      maxZoom={19}
      minZoom={9}
      maxBounds={[[36.5, -123.0], [38.1745, -121.0]]}
      gestureHandling
      style={{ height: '600px', width: '100%' }}
      className="br-300"
    >
      <TileLayer
        url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
        attribution='&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a>, © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={[37.36500921694882, -121.89034903653575]} icon={customIcon}>
        <Popup>
          Purple Lotus<br />752 Commercial St,<br /> San Jose, CA 95112
        </Popup>
      </Marker>
      <Marker position={[37.335607824006516, -121.89140077926427]} icon={customIcon}>
        <Popup>
          66 West Santa Clara St,<br /> San Jose, CA
        </Popup>
      </Marker>
    </MapContainer>
    </div>
  );
}
